import { _ as _extends } from "../extends-e61fd370.js";
import { _ as _objectWithoutProperties } from "../objectWithoutProperties-72d23964.js";
import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { a as DialogOverlay, D as DialogContent } from "../dialog.esm-cde5d438.js";
import { a as IconButton } from "../index-42d204df.js";
import "../typeof-6c6d8d7a.js";
import "../portal.esm-613949dc.js";
import "../utils.esm-514fad91.js";
import "../warning-ed2bf294.js";
import 'react-dom';
import "../setPrototypeOf-38804714.js";
import "../defineProperty-18999f8e.js";
import "../slicedToArray-5b664d46.js";
import "../toConsumableArray-f2f53597.js";
import "../index-81a9bdac.js";
import "../icon/assets/icon-map/index.js";
import "../icon/assets/AbTesting.js";
import "../icon/assets/Ad.js";
import "../icon/assets/AddressBook.js";
import "../icon/assets/Admin.js";
import "../icon/assets/Alarm.js";
import "../icon/assets/AlarmOff.js";
import "../icon/assets/AlarmRing.js";
import "../icon/assets/AlertCircle.js";
import "../icon/assets/AlertTriangle.js";
import "../icon/assets/Analytics.js";
import "../icon/assets/Archive.js";
import "../icon/assets/ArrowDown.js";
import "../icon/assets/ArrowDownMini.js";
import "../icon/assets/ArrowDownRightCurved.js";
import "../icon/assets/ArrowLeft.js";
import "../icon/assets/ArrowRight.js";
import "../icon/assets/ArrowUp.js";
import "../icon/assets/ArrowUpMini.js";
import "../icon/assets/ArrowUpRight.js";
import "../icon/assets/Attachment.js";
import "../icon/assets/Bag.js";
import "../icon/assets/BarChart.js";
import "../icon/assets/Bolt.js";
import "../icon/assets/Book.js";
import "../icon/assets/Bookmark.js";
import "../icon/assets/Bookmarks.js";
import "../icon/assets/BottomLeftRadius.js";
import "../icon/assets/BottomPadding.js";
import "../icon/assets/BottomRightRadius.js";
import "../icon/assets/BreakLink.js";
import "../icon/assets/Bug.js";
import "../icon/assets/Button.js";
import "../icon/assets/Calendar.js";
import "../icon/assets/CalendarDollar.js";
import "../icon/assets/CalendarEmpty.js";
import "../icon/assets/Camera.js";
import "../icon/assets/Cart.js";
import "../icon/assets/CenterAlign.js";
import "../icon/assets/ChatConversation.js";
import "../icon/assets/ChatMessage.js";
import "../icon/assets/Check.js";
import "../icon/assets/CheckCircle.js";
import "../icon/assets/CheckCircleFilled.js";
import "../icon/assets/CheckMini.js";
import "../icon/assets/CheckSquare.js";
import "../icon/assets/CheckSquareEmpty.js";
import "../icon/assets/CheckSquareFilled.js";
import "../icon/assets/Circle.js";
import "../icon/assets/CircleFilled.js";
import "../icon/assets/Clicks.js";
import "../icon/assets/Clock.js";
import "../icon/assets/Close.js";
import "../icon/assets/CloseCircle.js";
import "../icon/assets/CloseCircleFilled.js";
import "../icon/assets/CloseCircleFilledMini.js";
import "../icon/assets/CloseMini.js";
import "../icon/assets/CloudCheck.js";
import "../icon/assets/CloudError.js";
import "../icon/assets/CloudUpload.js";
import "../icon/assets/Code.js";
import "../icon/assets/CodeFile.js";
import "../icon/assets/ColdSubscriber.js";
import "../icon/assets/ColorPalette.js";
import "../icon/assets/Columns.js";
import "../icon/assets/Copy.js";
import "../icon/assets/Cost.js";
import "../icon/assets/CreatorNetwork.js";
import "../icon/assets/CreditCard.js";
import "../icon/assets/Crop.js";
import "../icon/assets/Crossroads.js";
import "../icon/assets/Cube.js";
import "../icon/assets/CustomField.js";
import "../icon/assets/Dashboard.js";
import "../icon/assets/Database.js";
import "../icon/assets/Delete.js";
import "../icon/assets/Design.js";
import "../icon/assets/DeviceDesktop.js";
import "../icon/assets/DeviceLaptop.js";
import "../icon/assets/DeviceMobile.js";
import "../icon/assets/DeviceTablet.js";
import "../icon/assets/DevicesDesktopMobile.js";
import "../icon/assets/DollarRepeat.js";
import "../icon/assets/Down.js";
import "../icon/assets/Download.js";
import "../icon/assets/DownloadFile.js";
import "../icon/assets/Drop.js";
import "../icon/assets/Edit.js";
import "../icon/assets/Education.js";
import "../icon/assets/Email.js";
import "../icon/assets/EmailAddress.js";
import "../icon/assets/Emails.js";
import "../icon/assets/External.js";
import "../icon/assets/File.js";
import "../icon/assets/Files.js";
import "../icon/assets/Filter.js";
import "../icon/assets/Flag.js";
import "../icon/assets/Folder.js";
import "../icon/assets/FolderOpen.js";
import "../icon/assets/Folders.js";
import "../icon/assets/Form.js";
import "../icon/assets/Gift.js";
import "../icon/assets/Globe.js";
import "../icon/assets/GripDots.js";
import "../icon/assets/GripLines.js";
import "../icon/assets/Heading1.js";
import "../icon/assets/Heading2.js";
import "../icon/assets/Heading3.js";
import "../icon/assets/Heading4.js";
import "../icon/assets/Heading5.js";
import "../icon/assets/Heading6.js";
import "../icon/assets/Heart.js";
import "../icon/assets/HeartFilled.js";
import "../icon/assets/Highlight.js";
import "../icon/assets/Home.js";
import "../icon/assets/HorizontalSpacing.js";
import "../icon/assets/Hourglass.js";
import "../icon/assets/Image.js";
import "../icon/assets/ImageAdd.js";
import "../icon/assets/ImageGallery.js";
import "../icon/assets/Inbox.js";
import "../icon/assets/InformationCircle.js";
import "../icon/assets/InlineSnippet.js";
import "../icon/assets/Keyboard.js";
import "../icon/assets/LandingPage.js";
import "../icon/assets/Layout.js";
import "../icon/assets/LayoutGrid.js";
import "../icon/assets/LayoutList.js";
import "../icon/assets/LayoutMasonry.js";
import "../icon/assets/Left.js";
import "../icon/assets/LeftAlign.js";
import "../icon/assets/LeftPadding.js";
import "../icon/assets/Lightbulb.js";
import "../icon/assets/Line.js";
import "../icon/assets/LineChart.js";
import "../icon/assets/LineFile.js";
import "../icon/assets/Link.js";
import "../icon/assets/LinkTrigger.js";
import "../icon/assets/LiquidCode.js";
import "../icon/assets/Lock.js";
import "../icon/assets/Logout.js";
import "../icon/assets/LongArrowDown.js";
import "../icon/assets/LongArrowLeft.js";
import "../icon/assets/LongArrowRight.js";
import "../icon/assets/LongArrowUp.js";
import "../icon/assets/MagicWand.js";
import "../icon/assets/MailAdd.js";
import "../icon/assets/MailRemove.js";
import "../icon/assets/Mailbox.js";
import "../icon/assets/Map.js";
import "../icon/assets/MapPin.js";
import "../icon/assets/Megaphone.js";
import "../icon/assets/Menu.js";
import "../icon/assets/MenuHorizontal.js";
import "../icon/assets/MenuVertical.js";
import "../icon/assets/Microphone.js";
import "../icon/assets/Minus.js";
import "../icon/assets/MinusCircle.js";
import "../icon/assets/MinusSquare.js";
import "../icon/assets/MinusSquareFilled.js";
import "../icon/assets/Money.js";
import "../icon/assets/MusicNote.js";
import "../icon/assets/Newspaper.js";
import "../icon/assets/None.js";
import "../icon/assets/Number.js";
import "../icon/assets/OnePerson.js";
import "../icon/assets/OpenEmailEmpty.js";
import "../icon/assets/OpenEmailFile.js";
import "../icon/assets/OrderedList.js";
import "../icon/assets/Outbox.js";
import "../icon/assets/Pages.js";
import "../icon/assets/PaintBucket.js";
import "../icon/assets/Paragraph.js";
import "../icon/assets/ParagraphIndentFirstLine.js";
import "../icon/assets/ParagraphJustifiedAlign.js";
import "../icon/assets/ParagraphSpacing.js";
import "../icon/assets/Pause.js";
import "../icon/assets/Payment.js";
import "../icon/assets/PdfFile.js";
import "../icon/assets/PencilWrite.js";
import "../icon/assets/Percent.js";
import "../icon/assets/PersonAdd.js";
import "../icon/assets/Personalization.js";
import "../icon/assets/PersonRemove.js";
import "../icon/assets/Phone.js";
import "../icon/assets/PieChart.js";
import "../icon/assets/PiggyBank.js";
import "../icon/assets/Pin.js";
import "../icon/assets/PinRemove.js";
import "../icon/assets/Play.js";
import "../icon/assets/PlayCircle.js";
import "../icon/assets/PlayPause.js";
import "../icon/assets/Plug.js";
import "../icon/assets/Plus.js";
import "../icon/assets/PlusCircle.js";
import "../icon/assets/PlusCircleFilled.js";
import "../icon/assets/Print.js";
import "../icon/assets/Profile.js";
import "../icon/assets/Puzzle.js";
import "../icon/assets/QuestionCircle.js";
import "../icon/assets/Quote.js";
import "../icon/assets/Rec.js";
import "../icon/assets/ReceiptSlip.js";
import "../icon/assets/RecList.js";
import "../icon/assets/RecPaid.js";
import "../icon/assets/RecPerson.js";
import "../icon/assets/Redo.js";
import "../icon/assets/Refresh.js";
import "../icon/assets/Repeat.js";
import "../icon/assets/Reply.js";
import "../icon/assets/ReplyAll.js";
import "../icon/assets/Resize.js";
import "../icon/assets/Right.js";
import "../icon/assets/RightAlign.js";
import "../icon/assets/RightPadding.js";
import "../icon/assets/Rocket.js";
import "../icon/assets/Route.js";
import "../icon/assets/Rss.js";
import "../icon/assets/Rules.js";
import "../icon/assets/Save.js";
import "../icon/assets/Search.js";
import "../icon/assets/Section.js";
import "../icon/assets/Security.js";
import "../icon/assets/Segment.js";
import "../icon/assets/Send.js";
import "../icon/assets/SendScheduled.js";
import "../icon/assets/Seo.js";
import "../icon/assets/SettingsCog.js";
import "../icon/assets/SettingsSliders.js";
import "../icon/assets/SettingsTune.js";
import "../icon/assets/SettingsWrench.js";
import "../icon/assets/Share.js";
import "../icon/assets/SidebarLeft.js";
import "../icon/assets/SidebarRight.js";
import "../icon/assets/Slideshow.js";
import "../icon/assets/Sort.js";
import "../icon/assets/Sparkle.js";
import "../icon/assets/Stairs.js";
import "../icon/assets/Star.js";
import "../icon/assets/StarCircle.js";
import "../icon/assets/StarFilled.js";
import "../icon/assets/Stopwatch.js";
import "../icon/assets/Support.js";
import "../icon/assets/SwatchBook.js";
import "../icon/assets/Table.js";
import "../icon/assets/Tag.js";
import "../icon/assets/TagTrigger.js";
import "../icon/assets/TagMinus.js";
import "../icon/assets/TagMoney.js";
import "../icon/assets/TagPlus.js";
import "../icon/assets/Target.js";
import "../icon/assets/Tasks.js";
import "../icon/assets/Template.js";
import "../icon/assets/TextBold.js";
import "../icon/assets/TextItalic.js";
import "../icon/assets/TextSize.js";
import "../icon/assets/TextStrikethrough.js";
import "../icon/assets/TextUnderline.js";
import "../icon/assets/ThumbsUpShine.js";
import "../icon/assets/ThreePeople.js";
import "../icon/assets/TipJar.js";
import "../icon/assets/Tools.js";
import "../icon/assets/TopLeftRadius.js";
import "../icon/assets/TopPadding.js";
import "../icon/assets/TopRightRadius.js";
import "../icon/assets/Trophy.js";
import "../icon/assets/TwoPeople.js";
import "../icon/assets/Undo.js";
import "../icon/assets/Unlock.js";
import "../icon/assets/UnorderedList.js";
import "../icon/assets/Up.js";
import "../icon/assets/Upload.js";
import "../icon/assets/UploadFile.js";
import "../icon/assets/UserFile.js";
import "../icon/assets/VerticalSpacing.js";
import "../icon/assets/Video.js";
import "../icon/assets/View.js";
import "../icon/assets/ViewOff.js";
import "../icon/assets/Wallet.js";
import "../social-icon/index.js";
import '@fortawesome/react-fontawesome';
import "../social-icon/icons.js";
import "../social-icon/library.js";
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/free-solid-svg-icons';
import '@fortawesome/free-brands-svg-icons';
import "../tooltip/index.js";
import "../auto-id.esm-2b54f757.js";
import '@reach/visually-hidden';
import "../portal/index.js";
import "../use-rerender-once/index.js";
import "../use-force-update/index.js";
import "../button/button-group.js";
import "../inject-css-ccd0a386.js";
var _excluded = ["children", "label", "onClose", "className", "heading"];

function Drawer(_ref) {
  var children = _ref.children,
      label = _ref.label,
      onClose = _ref.onClose,
      className = _ref.className,
      heading = _ref.heading,
      props = _objectWithoutProperties(_ref, _excluded);

  var defaultDrawerClass = "\n    bg-white\n    flex\n    flex-col\n    fixed\n    font-sans\n    h-full\n    max-w-2xl\n    p-0\n    right-0\n    rounded\n    shadow\n    top-0\n    w-4/5\n  ";
  var headingClass = cx("flex", "justify-between", "items-center", "p-6", {
    "border-b": !!heading,
    "border-gray-200": !!heading
  });
  var drawerClass = cx(className, defaultDrawerClass);
  var headingTitleClass = "\n    text-gray-800\n    text-2xl\n    font-semibold\n  ";
  return /*#__PURE__*/React__default.createElement(DialogOverlay, _extends({
    onDismiss: onClose
  }, props), /*#__PURE__*/React__default.createElement(DialogContent, {
    key: "modal-content",
    "aria-label": label,
    className: drawerClass,
    style: {
      marginTop: 0,
      animation: "0.5s ease-in-out 0s 1 slide-in-from-right"
    }
  }, /*#__PURE__*/React__default.createElement("header", {
    className: headingClass
  }, typeof heading === "string" ? /*#__PURE__*/React__default.createElement("p", {
    className: headingTitleClass
  }, heading) : heading, /*#__PURE__*/React__default.createElement(IconButton, {
    icon: "close",
    is: "plain",
    label: "Close drawer",
    onClick: onClose
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "p-6 overflow-y-auto h-full flex-1"
  }, children)));
}

Drawer.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  className: PropTypes.string,
  heading: PropTypes.string,
  onClose: PropTypes.func.isRequired
};
export { Drawer as default };